<section fxFlex="100" fxLayout="column">
  <div class="brand-plp-content-wrapper" fxLayout="column">
    <app-breadcrumbs [isOnlyHomeActive]="true" [isDesktop]="!isMobileOrTablet"> </app-breadcrumbs>

    <app-page-content-wrapper class="brand-plp-content-wrapper__component" [appStoryblokEditable]="storyEditable">
      <ng-container *ngIf="isServer; else isClientSide">
        <div class="brand-plp-content-wrapper__component__cover"></div>
      </ng-container>
    </app-page-content-wrapper>
  </div>
</section>

<ng-template #isClientSide>
  <ng-container
    *ngTemplateOutlet="
      !(isProductsLoadedOnce$ | async) || isPageLoading || (showBrandPLPLoading$ | async)
        ? brandPlpLoading
        : productListPage
    "
  >
  </ng-container>
</ng-template>
<ng-template #brandPlpLoading>
  <app-brand-plp-loading
    [isMobile]="isMobile"
    [isTablet]="isTablet"
    [isDesktop]="isDesktop"
    [isLandScapeTablet]="isLandScapeTablet"
  >
  </app-brand-plp-loading>
</ng-template>

<ng-template #productListPage>
  <app-brand-plp-brand-info
    [brandInfo]="brandInfo$ | async"
    [categories]="categories"
    [isMobileOrTablet]="isMobileOrTablet"
    [storyBrandContent]="storyBrandContent"
  >
  </app-brand-plp-brand-info>

  <!-- Storyblok dynamic component for topContent -->
  <div *ngIf="storyTopContent?.length">
    <div *ngFor="let blok of storyTopContent" [appStoryblokEditable]="blok._editable">
      <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="buildInputs(blok)">
      </ndc-dynamic>
    </div>
  </div>

  <app-brand-plp-body
    [products]="products$ | async"
    [isMobile]="isMobile"
    [isTablet]="isTablet"
    [isDesktop]="!isMobileOrTablet"
    [isMobileOrTablet]="isMobileOrTablet"
    [totalCount]="productsTotalCount$ | async"
    [queryParams]="queryParams$ | async"
    [categories]="categories"
    [brandName]="(brandInfo$ | async).name"
    [storyBottomContent]="storyBottomContent"
    [storyEditable]="storyEditable"
  >
  </app-brand-plp-body>
</ng-template>
